module.exports = __webpack_public_path__ + "img/estadios.ca047830.jpg";